import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-fill text-background-50 text-lg"></i>
                </span>
                <span className="text-lg font-bold text-background-50 font-heading">
                  人人影院
                </span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed">
                免费高清在线观看，最新电影电视剧不缓冲追剧，海量影视全集每日更新。让每个人都能享受高品质影视内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                影视分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-secondary-300 hover:text-background-50 cursor-pointer transition-colors duration-200"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/"
                    className="text-sm text-secondary-300 hover:text-background-50 cursor-pointer transition-colors duration-200"
                  >
                    首页
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-secondary-300 hover:text-background-50 cursor-pointer transition-colors duration-200"
                  >
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/dianying"
                    className="text-sm text-secondary-300 hover:text-background-50 cursor-pointer transition-colors duration-200"
                  >
                    最新电影
                  </Link>
                </li>
                <li>
                  <Link
                    to="/category/dianshiju"
                    className="text-sm text-secondary-300 hover:text-background-50 cursor-pointer transition-colors duration-200"
                  >
                    热播剧集
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                联系方式
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <span className="w-4 h-4 inline-flex items-center justify-center">
                    <i className="ri-mail-line text-xs"></i>
                  </span>
                  contact@renrencinema.com
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <span className="w-4 h-4 inline-flex items-center justify-center">
                    <i className="ri-customer-service-line text-xs"></i>
                  </span>
                  在线客服：每日 9:00-24:00
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-400">
              &copy; {new Date().getFullYear()} 人人影院 RenRenCinema. All
              Rights Reserved.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="text-xs text-secondary-400 hover:text-background-50 cursor-pointer transition-colors duration-200"
                rel="nofollow"
              >
                隐私政策
              </a>
              <a
                href="#"
                className="text-xs text-secondary-400 hover:text-background-50 cursor-pointer transition-colors duration-200"
                rel="nofollow"
              >
                服务条款
              </a>
              <a
                href="#"
                className="text-xs text-secondary-400 hover:text-background-50 cursor-pointer transition-colors duration-200"
                rel="nofollow"
              >
                DMCA
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}